<template>
  <div
    v-if="affiliateCustomizations"
    id="embeddedView"
    class="embedded grid-lg-aside"
    :style="appStyleProps">
    <EmbeddedApplicationNav />
    <AppNav
      v-if="currentApp.type === 'sba-complete'"
      :portal="false"
      :hide-app-cta="true"
      class="portal-app-nav"
    />
    <div data-smooth-scroll="main" class='embedded-content-container'>
      <section class='embedded-content'>
        <slot />
      </section>
      <EmbeddedFooter />
    </div>
    <ChatBot v-if="chatEnabled"/>
  </div>
  <div v-else></div>
</template>

<script>
import EmbeddedFooter from '~/components/embedded/EmbeddedFooter'
import EmbeddedApplicationNav from '~/components/embedded/EmbeddedApplicationNav'
import AppNav from "~/components/AppNav";
import { mapState } from 'pinia'
import SmoothScroll from '~/libs/smooth-scroll'
import { useProgressStore } from '~/store/progress'
import { useUserStore } from '~/store/user'
import { useRootStore } from '~/store/root'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import ChatBot from '~/components/ChatBot'
import env from '~/libs/env'

export default {
  components: {
    EmbeddedFooter,
    EmbeddedApplicationNav,
    AppNav,
    ChatBot
  },
  setup() {
    const rootStore = useRootStore()
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    rootStore.setPageTitle(affiliateCustomizationsStore.headTitlePrefix + ' - Application')

    if (!env('useTenantTheme') === true) {
      rootStore.setLendioFavicons()
    } else {
      rootStore.setBlankFavicons()
    }

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
    })
  },
  data() {
    return {}
  },
  watch: {
    '$route.path' () {
      SmoothScroll.goTo(0)
      SmoothScroll.scrollElementsTop('[data-smooth-scroll="main"]')
    }
  },
  computed: {
    ...mapState(useRootStore, {
      authUser: (store) => store.authUser,
    }),
    ...mapState(useAffiliateCustomizationStore, [
      'appStyleProps',
      'affiliateCustomizations',
      'chatEnabled',
    ]),
    ...mapState(useProgressStore, ['currentApp']),

  },
  async mounted() {
    await useProgressStore().fetchProgress()
    await useProgressStore().updateApplication()
    const piniaUserStore = useUserStore()
    await piniaUserStore.loadFreshLogin()
  }
}
</script>

<style lang='scss'>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-app';


#embeddedView,
#embeddedBase,
#embeddedPortal {
  @include affiliateCustomizedApp();
}


.embedded-content-container {
  max-width: 800px;
}

.mp-transition-enter-active {
  left: 100%;
  opacity: 0;
  transition: left 0.25s ease-out, opacity 0.15s ease-out;
}

.mp-transition-enter-active {
  position: relative;
}

.mp-transition-enter-to {
  opacity: 1;
  left: 0%;
}

.mp-transition-back-enter-active {
  right: 100%;
  opacity: 0;
  transition: right 0.25s ease-out, opacity 0.15s ease-out;
}

.mp-transition-back-enter-active {
  position: relative;
  @include media-breakpoint-up(lg) {
    right: 10%;
  }
}

.mp-transition-back-enter-to {
  opacity: 1;
  right: 0%;
}

.mp-transition-leave, .mp-transition-back-leave {
  opacity: 1;
}

.mp-transition-leave-active, .mp-transition-back-leave-active {
  transition: opacity 0.15s linear;
}

.mp-transition-leave-to, .mp-transition-back-leave-to {
  opacity: 0;
}
</style>
